/**
 * Estensione di Vue che inserisce un interceptor in tutte le chiamate http aggiungendo l'header di autenticazione
 * @module auth
 */
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import { API_URL } from '@/utils'

export default {

    install(Vue, options) {

        Vue.http.interceptors.push((request, next) => {
            const hasAuthHeader = request.headers.has('Authorization')
            const token = store.state.auth.accessToken;

            if (token && !hasAuthHeader) {
                this.setAuthHeader(request)
            }

            next()
        })

    },

    setAuthHeader(request) {
        request.headers.set('Authorization', 'Bearer ' + store.state.auth.accessToken)
    }
}


// WEBPACK FOOTER //
// ./src/auth.js